module.exports = __webpack_public_path__ + "static/media/075-antigua-and-barbuda.29731ac7.svg";